module.exports = __webpack_public_path__ + "static/media/emailCampaigns.mobile.4760c59b.svg";